import React from "react";
import { connect } from "react-redux";
import styled from "@emotion/styled";
import { shortnameSelector, isLoggedIn } from "modules/session/selectors";
import { loadMyProfile } from "modules/playground/action";

import PlaygroundNavbar from "components/PlaygroundNavbar";
import PlaygroundNameNavbar from "components/PlaygroundNameNavbar";

const Container = styled.div`
  width: 100%;
`;

function DashboardLayout(props) {
  React.useState(() => {
    if (props.isLoggedIn) {
      props.loadMyProfile();
    }
  }, []);

  const active = props.location.pathname.split("/");

  return (
    <Container>
      <PlaygroundNameNavbar name={props.name} />
      {(props.location.pathname == "/play" ||
        props.location.pathname == "/play/id" ||
        props.location.pathname == "/play/history") && (
        <PlaygroundNavbar active="dashboard" />
      )}
      {props.location.pathname != "/play" &&
        props.location.pathname != "/play/id" &&
        props.location.pathname != "/play/history" && (
          <PlaygroundNavbar active={active[2]} />
        )}
      {props.children}
    </Container>
  );
}

const withConnect = connect(
  state => ({
    name: shortnameSelector(state),
    isLoggedIn: isLoggedIn(state)
  }),
  {
    loadMyProfile
  }
);

export default withConnect(DashboardLayout);
